import { Button, Grid, Group, Text } from '@mantine/core';
import ContentPaper from '../../../components/layouts/rfs/Content';
import RfsLayout from '../../../components/layouts/RfsLayout';
import { AvicContext, Provider } from './context';
import { Form } from './form';
import { useContext } from 'react';
import { AppLoader } from '../../../components/common/loader';
import AvicTable from './table';
import { AuthContext } from '../../../contexts/AuthContext';
import { crRoles } from '../../../constants';
import { InfoCircle } from 'tabler-icons-react';
import { Header } from '../stockPriceExtension/selectSku';

const Content = () => {
  const {
    fetch,
    submit,
    saveLoading,
    loading,
    channels,
    hasNewChannel,
    onChannelChange,
    hasChannel,
    canDisplayAvic,
    reset,
  } = useContext(AvicContext);

  const Footer = () => (
    <Grid justify='flex-end'>
      <Grid.Col span={2}>
        <Button
          variant='gradient'
          color='primary'
          fullWidth
          disabled={saveLoading || loading || (!hasChannel() && !canDisplayAvic())}
          onClick={() => (hasChannel() ? submit() : fetch())}
        >
          {saveLoading || loading ? (
            <AppLoader size='sm' />
          ) : hasChannel() ? (
            'Submit'
          ) : (
            'Search Channels'
          )}
        </Button>
      </Grid.Col>
    </Grid>
  );

  return (
    <ContentPaper footer={hasChannel() ? hasNewChannel() ? <Footer /> : null : <Footer />}>
      <Header heading={'AVIC EXTENSION'} backAction={hasChannel() ? reset : null} />

      {hasChannel() ? (
        <AvicTable channels={channels} loading={loading} onChannelChange={onChannelChange} />
      ) : (
        <Form />
      )}
    </ContentPaper>
  );
};

const AvicChannelExtension = () => {
  const { crUserRoles } = useContext(AuthContext);
  const allowedRoles = [crRoles.fpna_brewery_heads, crRoles.gcc];
  return (
    <Provider>
      <RfsLayout>
        {allowedRoles.some((role) => crUserRoles.includes(role)) ? (
          <Content />
        ) : (
          <ContentPaper>
            <Grid>
              <Grid.Col span={12}>
                <Group className='disclaimer-modal-group'>
                  <InfoCircle color='black' size='2rem' />
                  <Text align='center'>
                    You do not have access to this page. Contact the administrator to obtain
                    permission.
                  </Text>
                </Group>
              </Grid.Col>
            </Grid>
          </ContentPaper>
        )}
      </RfsLayout>
    </Provider>
  );
};

export default AvicChannelExtension;
